import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {
  allProgramsData: [],
  allPrograms: [],
  programs: { programsData: [], count: 0 },
  programDetail: {},
};

export const getAllPrograms = createAsyncThunk(
  "programData/getAllPrograms",
  async (payload) => {
    try {
      const response = await allAPI.programs.getPrograms(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createProgram = createAsyncThunk(
  "programData/createProgram",
  async (payload) => {
    try {
      let pagination = payload.pagination;
      delete payload.pagination;
      const response = await allAPI.programs.createPrograms(payload);
      if (response.status === 201 && pagination) {
        return { data: response.data, pagination: pagination };
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createProgramNew = createAsyncThunk(
  "programData/createProgramNew",
  async (payload) => {
    try {
      let pagination = payload.pagination;
      delete payload.pagination;
      const response = await allAPI.programs.createProgramsNew(payload);
      if (response.status === 201 && pagination) {
        return { data: response.data, pagination: pagination };
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

export const updateProgram = createAsyncThunk(
  "programData/updateProgram",
  async (payload) => {
    try {
      const { ID, pagination, created_at, updated_at, Customers, ProgramServices, ...rest } = payload;
      const response = await allAPI.programs.updateProgram(ID, rest);
      if (response.status === 201 || response.status === 200) {
        return { data: response.data, pagination: pagination };
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  },
);

const programSlice = createSlice({
  name: "programData",
  initialState,
  reducers: {
    setProgram: (state, action) => {
      state.programDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPrograms.pending, (state) => {
        console.log("pending");
      })
      .addCase(getAllPrograms.fulfilled, (state, action) => {
        console.log(action.payload, "response");
        // Defensive: if state has been corrupted (e.g. a persisted string),
        // return a fresh object shaped like the initial state with the
        // appropriate field populated to avoid runtime TypeErrors.
        if (typeof state !== "object" || state === null) {
          if (action?.programsData) {
            return { ...initialState, programs: action };
          } else if (action?.[0]?.ProgramServices) {
            return { ...initialState, allProgramsData: action };
          } else {
            return { ...initialState, allPrograms: action };
          }
        }

        if (action.payload?.programsData) {
          state.programs = action.payload;
        } else if (action?.payload?.[0]?.ProgramServices) {
          state.allProgramsData = action.payload;
        } else {
          state.allPrograms = action.payload;
        }
      })
      .addCase(getAllPrograms.rejected, (state, action) => {
        if (typeof state !== "object" || state === null) {
          return { ...initialState, programs: { programsData: [], count: 0 }, allProgramsData: [], allPrograms: [] };
        }

        state.programs = { programsData: [], count: 0 };
        state.allProgramsData = [];
        state.allPrograms = [];

        console.log("rejected", action.error.message);
      })
      .addCase(createProgram.pending, (state) => {
        console.log("pending");
      })
      .addCase(createProgram.fulfilled, (state, action) => {
        if (typeof state !== "object" || state === null) {
          // Create a new state with the created program
          return {
            ...initialState,
            programs: {
              programsData: [action.payload.data.data],
              count: 1,
            },
          };
        }

        let currentPage = action.payload.pagination.pageIndex;
        let currentPageSize = action.payload.pagination.pageSize;
        state.programs.count = (state.programs.count || 0) + 1;

        if (currentPage + 1 * currentPageSize > state.programs.count) {
          state.programs.programsData = [
            ...(state.programs.programsData || []),
            action.payload.data.data,
          ];
        }
      })
      .addCase(createProgram.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      })

      .addCase(createProgramNew.pending, (state) => {
        console.log("pending");
      })
      .addCase(createProgramNew.fulfilled, (state, action) => {
        if (typeof state !== "object" || state === null) {
          return {
            ...initialState,
            programs: {
              programsData: [action.payload.data.data],
              count: 1,
            },
          };
        }

        let currentPage = action.payload.pagination.pageIndex;
        let currentPageSize = action.payload.pagination.pageSize;
        state.programs.count = (state.programs.count || 0) + 1;

        if (currentPage + 1 * currentPageSize > state.programs.count) {
          state.programs.programsData = [
            ...(state.programs.programsData || []),
            action.payload.data.data,
          ];
        }
      })
      .addCase(createProgramNew.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      })
      .addCase(updateProgram.pending, (state) => {
        console.log("pending");
      })
      .addCase(updateProgram.fulfilled, (state, action) => {
        if (typeof state === "object" && state !== null) {
          if (action.payload?.data?.data) {
            state.programDetail = action.payload.data.data;
          } else if (action.payload?.data) {
            state.programDetail = action.payload.data;
          }
        }
      })
      .addCase(updateProgram.rejected, (state, action) => {
        console.log("rejected", action.error.message);
      });
  },
});

export const { setProgram } = programSlice.actions;

export default programSlice.reducer;
